/** @format */

import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'splitContentPipe',
	standalone: true
})
export class SplitContentPipe implements PipeTransform {
	transform(values: string[] | null | undefined, separator = '|'): string {
		if (!values || !Array.isArray(values)) {
			return '';
		}
		return values.join(` ${separator} `);
	}
}
